import { getTempInfo } from "../../shared/tempInfo";
export default (PiNode => {
  Object.defineProperties(PiNode.prototype, {
    tempInfo: {
      get() {
        return getTempInfo(this.data);
      }
    }
  });
});